import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { PaginatedWarehouseMemberAccesses } from 'contracts/WarehouseMemberAccesses';
import type { Pagination } from 'contracts/Pagination';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data', 'pagination'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'PAGINATE_WAREHOUSE_MEMBER_ACCESS_',
  }
);

export interface PaginateWarehouseMemberAccessesState {
  data: PaginatedWarehouseMemberAccesses[];
  pagination?: Pagination;
  loading: boolean;
  errorMessage: string | null;
}

export interface PaginateWarehouseMemberAccessesRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: PaginatedWarehouseMemberAccesses[];
  pagination: Pagination;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: PaginateWarehouseMemberAccessesState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: PaginateWarehouseMemberAccessesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (
  state: PaginateWarehouseMemberAccessesState,
  action: SuccessAction
) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination },
  });

const failure = (
  state: PaginateWarehouseMemberAccessesState,
  action: FailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: PaginateWarehouseMemberAccessesState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const paginateWarehouseMemberAccesses = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const PaginateWarehouseMemberAccessesTypes = Types;
export const PaginateWarehouseMemberAccessesActions = Creators;
